<ng-container *ngIf="!linkModal">
  <img [src]="thumbnail" (click)="showVideo()" *ngIf="thumbnail" />
  <ng-container *ngIf="!thumbnail">
    <img
      [src]="youtubeThumbnail"
      (click)="showVideo()"
      *ngIf="youtubeThumbnail$ | async as youtubeThumbnail"
    />
  </ng-container>
  <span smSvgIcon="play" class="play-icon" (click)="showVideo()"></span>
</ng-container>

<dialog
  (click)="closeDialog()"
  @fade
  open
  *ngIf="youtubeEmbedLink$ | async as youtubeEmbedLink"
  class="popup-video"
>
  <span smSvgIcon="close"></span>
  <iframe [src]="youtubeEmbedLink"></iframe>
</dialog>
